(function () {
  function initGallery(gallery) {
    if (gallery.dataset.zoomInitialized) return;
    gallery.dataset.zoomInitialized = 'true';
    var dialog = gallery.parentElement.querySelector('[data-gallery-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var triggers = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-index]'));
    var image = dialog.querySelector('[data-gallery-full-image]');
    var zoomButton = dialog.querySelector('[data-gallery-zoom]');
    var counter = dialog.querySelector('[data-gallery-counter]');
    var previous = dialog.querySelector('[data-gallery-prev]');
    var next = dialog.querySelector('[data-gallery-next]');
    var index = 0;
    var lastTrigger = null;
    function show(i) {
      index = (i + triggers.length) % triggers.length;
      var original = triggers[index].querySelector('img');
      if (!original) return;
      var source = original.currentSrc || original.src;
      // Shopify's image CDN accepts a larger width for the detail viewer.
      var highRes = source.replace(/([?&])width=\d+/, '$1width=2400');
      image.src = highRes;
      image.alt = original.alt || 'Product photo ' + (index + 1);
      zoomButton.classList.remove('is-zoomed');
      zoomButton.scrollTop = 0;
      zoomButton.scrollLeft = 0;
      counter.textContent = 'Image ' + (index + 1) + ' of ' + triggers.length;
      previous.hidden = next.hidden = triggers.length < 2;
    }
    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        show(i);
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-gallery-close]').addEventListener('click', function () { dialog.close(); });
    previous.addEventListener('click', function () { show(index - 1); });
    next.addEventListener('click', function () { show(index + 1); });
    zoomButton.addEventListener('click', function () { zoomButton.classList.toggle('is-zoomed'); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { if (lastTrigger) lastTrigger.focus(); });
    var touchStart = null;
    zoomButton.addEventListener('touchstart', function (e) { if (e.touches.length === 1) touchStart = e.touches[0].clientX; }, { passive: true });
    zoomButton.addEventListener('touchend', function (e) {
      if (touchStart === null || zoomButton.classList.contains('is-zoomed') || !e.changedTouches.length) return;
      var delta = e.changedTouches[0].clientX - touchStart;
      touchStart = null;
      if (Math.abs(delta) > 65) show(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
  }
  function init() { document.querySelectorAll('[data-product-gallery]').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

